import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { BxBreadcrumb, BxTabComponent, BxTabGroupComponent, injectBxIcons, file05Icon } from '@beyonnex/bx-angular-ui';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ROUTES } from '../../app.models';
import { PageComponent } from '../page/page.component';
import { EiImportComponent } from './ei-import/ei-import.component';
import { QundisImportComponent } from './qundis-import/qundis-import.component';
import { TadoDraginoImportComponent } from './tado-dragino-import/tado-dragino-import.component';

@Component({
  selector: 'bxi-els-import',
  imports: [
    PageComponent,
    TranslatePipe,
    BxTabComponent,
    BxTabGroupComponent,
    TadoDraginoImportComponent,
    QundisImportComponent,
    EiImportComponent,
  ],
  templateUrl: './els-import.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElsImportComponent {
  private readonly translate = inject(TranslateService);

  protected readonly breadcrumbOptions = signal<BxBreadcrumb[]>([
    { label: this.translate.instant('navigation.elsImport'), route: `/${ROUTES.ELS_IMPORT}` },
  ]);

  constructor() {
    injectBxIcons([file05Icon]);
  }
}
